export const DataType = {
  STRING: 'string',
  BOOLEAN: 'boolean',
  DECIMAL: 'decimal',
  INTEGER: 'integer',
  DATE: 'date'
}

export const NumberFormatting = {
    NONE: 'none',
    NUMBER: 'number',
    CURRENCY: 'currency'
}

export const Mode = {
    EDIT: 'edit', // display on the editor
    SETTINGS: 'settings', // display settings (right panel) on editor
    TOOLBAR_ITEM: 'toolbar-item', // display on toolbar (left) on editor
    FILL: 'fill', // display when form is being filled
    VIEW: 'view' // display uneditable form field
}

export const ViewMode = {
    PRETTY: 'pretty',
    FORM: 'form'
}

export const Format = {
    URL: 'url',
    EMAIL: 'email'
}


export const FormatRegExp = {
    // URL format hat tip to https://gist.github.com/dperini/729294
    URL: /^(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,
    EMAIL: /^[a-z0-9]+([-+._][a-z0-9]+)*@[a-z0-9]+([-_.][a-z0-9]+)*\.[a-z0-9]+([-_.][a-z0-9]+)*$/i
}

export const NumericalValidationLimits = {
    MIN: -Math.pow(2, 31), // -2147483648
    MAX: Math.pow(2, 31) - 1 // 2147483647
}


export const castDataType = (value, dataType) => {
    switch (dataType) {
        case DataType.INTEGER:
            // Remove spaces to avoid cutting the number when parsing
            let i = parseInt((String(value) || '').replace(/ /g, ''), 10);
            return isNaN(i) ? null : i;
        case DataType.DECIMAL:
            // Remove spaces to avoid cutting the number when parsing
            let d = parseFloat((String(value) || '').replace(/ /g, ''));
            return isNaN(d) ? null : d;
        case DataType.BOOLEAN:
            return (value == 'true') ? true : (value == 'false') ? false : null;
        case DataType.DATE:
            const date = new Date(value)
            return value ? (date == "Invalid Date" ? null : dayjs(date).format('YYYY-MM-DD')) : value
        default:
            return value;
    }
}

export const CONTEXT_OPTIONS = Object.freeze({
  NONE: 'none',
  DATAGRID_PRESET: 'datagrid_preset',
  DATAGRID_ROW: 'datagrid_row'
})

export const ValidationType = {
    REQUIRED: 'required',
    INVALID: 'invalid'
}